// @flow
// @jsx h

import FreeOrderConfirmation from "./payment-confirmation/FreeOrderConfirmation.js";

declare var PHP_API_ENDPOINT: string;

// External librairies
import { h, Component } from "preact";
import Router from "preact-router";
import { route } from "preact-router";
import Match from "preact-router/match";
// import he from 'he';
import WebFont from "webfontloader";

// Translations
import { IntlProvider } from "preact-i18n";
import ca from "../translations/ca.json";
import de from "../translations/de.json";
import en from "../translations/en.json";
import es from "../translations/es.json";
import fr from "../translations/fr.json";
import it from "../translations/it.json";
import nl from "../translations/nl.json";

// Styles and theming
import styles from "./style.scss";
import { ThemeConfigProvider } from "elc-theme";

// Components
import Error from "./error/index.js";
import Header from "./header/Header.js";
import Redirect from "./redirect/index.js";
import Products from "./products/index.js";
import Product from "./product/index.js";

import ClientForm from "elc-client-form";
import OrderSummary from "./order-summary/OrderSummary.js";
import OrderExpired from "./order-expired/OrderExpired.js";
import StripeError  from './stripe-payment/stripe-error/StripeError';
import PiError  from './stripe-payment/pi-error/PiError';

import Basket from "elc-basket";
import Loading from "elc-loading";
import Checkout from "./checkout/index.js";
import StripePayment from "./stripe-payment/index.js";
import Stripe3DSecureConfirmation from "./stripe-3D-secure-confirmation/index.js";
import PaymentConfirmation from "./payment-confirmation/PaymentConfirmation.js";
import ParticipantClientForms from "./participant-client-forms/ParticipantClientForms.js";
import ParticipantFormCreated from "./participant-form-created/ParticipantFormCreated.js";
import LoadCSS from "../service/load-css.js";
import {
  sendPurchaseEventGTM,
  sendUXEventGTM,
  sendCheckoutEventOrderGTM,
  sendDataLayerVariableGTM
} from "elc-commons";

// API methods
import { getToken, setGenerateTokenMethod, getOrderById, getParticipantClientForm, getParticipantClientData } from "elc-open-api";
import {
  generateTokenByOrderReference,
  getOrderByReference,
  getPaymentMethods,
  postOrderPayment,
  postOrderPaymentEmail,
  postParamsInURL
} from "elc-internal-api";

type WidgetProps = {};

type WidgetState = {
  loading: boolean,
  locale: Object,
  localeString: string,
  currency: Currency,
  productId?: number,
  productsListViewMode: boolean,
  currentOrder?: Order,
  dataAssurance:object | null,
  initAssuranceMeetch:object | null
};




class App extends Component<WidgetProps, WidgetState> {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      locale: fr,
      localeString: "fr",
      callbackStripe: undefined,
      currency: {
        // code: "EUR",
        // codeNumber: "978",
        // id: 2,
        // name: "Euro",
        // sign: "€",
        // symbol: "&euro;"
        active: true,
        id: 2,
        isoCode: "EUR",
        name: "Euro",
        numCode: 978,
        symbol: "&euro;"
      },
      isRedirectToPayment: false,
      orderRef: null,
      preview: false,
      productId: undefined,
      productPageUpdate: false,
      productsListViewMode: true,
      showBackToProduct: false,
      urlToShop: undefined,
      noPayment: false,
      sessionValid: true,
      dataAssurance:null,
      initAssuranceMeetch:null
    };
  }
  // constructor(props) {
  //   super(props);
  //   // get Widget hash from url
  //   const urlParts = window.location.href.split('/');
  //   this.setState({ hash: urlParts[3] });
  // }

  /**
   * Initiliaze the config for the widget
   * @param {string} hash
   * @param {object} config
   * @param {boolean} preview
   * @param {object} company
   */
  initConfig = (hash, config, preview, company) => {
    const searchParam = window.location.search;
    if (searchParam) {
      const getParams = searchParam.slice(
        searchParam.indexOf("=") + 1,
        searchParam.length
      );
      const parseParams = JSON.parse(decodeURIComponent(getParams));
      // console.log("parse config", parseParams);
      this.disabledReservation = parseParams.disabledReservation;
      this.options = parseParams;
    }
    parent.postMessage(`action=loaded&id_iframe=${hash}`, "*");
    // config.company.defaultCurrency.symbol = he.decode(
    //   config.company.defaultCurrency.symbol
    // );
    const font = this.getFont(parseInt(config.module.conf.font));
    if (font) {
      WebFont.load({
        google: {
          families: [font.value]
        }
      });
    }
    this.setState(
      {
        hash,
        config,
        preview,
        loading: false,
        company,
        currency: company._embedded.defaultCurrency,
        sessionValid: true,
        currentOrder: undefined,
        dataAssurance:null
      },
      () => {
        // Check if display_style should be as grid
        if (
          config.module.conf.display_style &&
          config.module.conf.display_style === "GRID"
        ) {
          this.setState({ productsListViewMode: false });
        }
        if (
          config.module.conf.mode === "product" &&
          config.module.conf.id_product
        ) {
          route(`/${hash}/products/${config.module.conf.id_product}`, true);
        } else if (config.module.conf.mode === "catalog") {
          route(`/${hash}/products`, true);
        } else {
          throw new Error(
            "Your Widget should be configured in mode catalog or product !"
          );
        }
        let convertToJson = function(str) {
          let hash;
          let json = {};
          let hashes = str.split(";");
          for (let i = 0; i < hashes.length; i++) {
            hash = hashes[i].split("=");
            json[hash[0]] = hash[1];
          }
          return json;
        };
        if (this.options && this.options.userInfo) {
          config.module.userInfo = convertToJson(this.options.userInfo);
        }
      }
    );
  };

  getFont(fontId) {
    return [
      {
        id: 1,
        value: "Open Sans"
      },
      {
        id: 2,
        value: "Indie Flower"
      },
      {
        id: 3,
        value: "Poiret One"
      },
      {
        id: 4,
        value: "Lobster"
      },
      {
        id: 5,
        value: "Rochester"
      },
      {
        id: 6,
        value: "Poppins"
      },
      {
        id: 7,
        value: "Balthazar"
      },
      {
        id: 8,
        value: "Concert One"
      },
      {
        id: 9,
        value: "Roboto Slab"
      },
      {
        id: 10,
        value: "Rokkitt"
      },
      {
        id: 11,
        value: "Sanchez"
      }
    ].find(font => font.id === fontId);
  }

  changeTranslation = country => {
    if (country === "GB" && this.state.localeString !== "en") {
      this.setState({ locale: en, localeString: "en" });
    } else if (country === "FR" && this.state.localeString !== "fr") {
      this.setState({ locale: fr, localeString: "fr" });
    } else if (country === "DE" && this.state.localeString !== "de") {
      this.setState({ locale: de, localeString: "de" });
    } else if (country === "ES" && this.state.localeString !== "es") {
      this.setState({ locale: es, localeString: "es" });
    } else if (country === "IT" && this.state.localeString !== "it") {
      this.setState({ locale: it, localeString: "it" });
    } else if (country === "NL" && this.state.localeString !== "nl") {
      this.setState({ locale: nl, localeString: "nl" });
    } else if (country === "PL" && this.state.localeString !== "ca") {
      this.setState({ locale: ca, localeString: "ca" });
    }
    sendUXEventGTM({
      event: "changeLanguage",
      "chosen-language": this.state.localeString
    });
  };

  getAssurance = ref => {
    this.initAssuranceMeetch(ref);
  };

  
  initAssuranceMeetch = ref => {
    // alert("initAssuranceMeetch")
    // console.log("params", ref)
    // console.log("this.state", this.state)

    const envList = {
      "demo" : 1,
      "preprod" : 2,
      "production" : 3,
      "dev" : 4,
    }
    const currentOrder = this.state.currentOrder ? this.state.currentOrder : this.state.previousOrder

    let data = [
      envList[ENV],
      currentOrder.id,
      currentOrder.reference,  
    ];
   

    if(this.state.dataAssurance && ref == 'json-addock-ajout-assurancev2'){
      const arrayAdresse = []
      Object.entries(this.state.dataAssurance).forEach(([key, value]) => {
        // console.log(`${key}: ${value}`);
        arrayAdresse.push(value);
      });
      data = [...data, ...arrayAdresse]
    }

    

      /****** */
      this.jsonp(ref ? ref : "json-addock-calc-assurancev2", data)
      .then((data) => {

        //this.setState({ initAssuranceMeetch: data });
        this.setState({ initAssuranceMeetch: data });
        if(data?.variations.length == 0){
          this.updateDataAssurance(null)
        }
      })
      .catch((error) => {
        console.error("Erreur:", error);
      });

  };

  jsonp = (ref, q) => {
    return new Promise((resolve, reject) => {
      const callbackName = 'cb' + Math.trunc(Math.random() * 10e10);
      const script = document.createElement('script');
      const encodedQ = q.map(v => encodeURIComponent(v ?? '')).join(',');
      script.src = 'https://etape-rest.for-system.com/index.aspx?ref='+encodeURIComponent(ref)+'&q='+encodedQ+'&callback=' + callbackName;

      window[callbackName] = (o) => {
        resolve(o);
        delete window[callbackName];
        document.head.removeChild(script);
      };

      document.head.append(script);    
    })
  }



  
  setOrder = order => {
    getPaymentMethods(
      this.state.config.company.id,
      order.id,
      this.state.config.type.toLowerCase()
    ).then(paymentMethods => {
      // console.log("paymentMethods", paymentMethods.find(
      //   paymentMethod => paymentMethod.baseModule.code === "creditcard"
      // ))
      this.setState({paymentMethod: paymentMethods.find(
        paymentMethod => paymentMethod.baseModule.code === "creditcard"
      )});
      
      this.setState({ currentOrder: order },
        () => {
          if(order && order.status !== "DRAFT" && order._embedded.userSaved && order.origin !== "OPEN_API" ){
            this.getAssurance()
          }
      });

       this.getAllParticipantClientForm(order)
        .then(({ hasForms }) => {
          if (!hasForms) {          
              route(`/order/${order.id}`);
          }
        })
        .catch(error => {
          console.error("Erreur getAllParticipantClientForm :", error);
        });

    

    });
    // getOrderById(order.id)
    //   .then(order => {


    //   return order;
    // })
    // .catch(error => this.setState({ error }));
  };

  updateDataAssurance = data => {
    //console.log("updateDataAssurance - data", data)
    this.setState({ dataAssurance: data });
  };

  setCurrentProduct = product => {
    this.setState({ currentProduct: product });
  };

  setConfirmedOrder = () => {
    this.setState({ currentOrder: undefined });
  };

  setOrderUser = (order, userClientData) => {
    route(`/order/${order.id}`);
    this.setState({ currentOrder: order, userClientData });
  };

  updateOrder = order => {
    this.setState({ currentOrder: order },
      () => {
        if(order && order.status !== "DRAFT" && order._embedded.userSaved && order.origin !== "OPEN_API" ){
          this.getAssurance()
        };
      })
  };

  setPaymentMethods = paymentMethods => {
    this.setState({
      paymentMethods
    });
  };

  setPiError = error => {
    this.setState({ piError: error });
    route(`/payment/error`);
  };

  goToConfirm = (paymentMethod, payment, hasParticipantClientForms) => {
    route(`/order/${this.state.currentOrder.id}/payment/confirmation`);
    this.setState(prevState => {
      return {
        loading: false,
        paymentMethod,
        payment,
        hasParticipantClientForms,
        currentOrder: undefined,
        previousOrder: prevState.currentOrder,
        sessionValid:true,
        initAssuranceMeetch : null
      };
    });
    const order = this.state.currentOrder
      ? this.state.currentOrder
      : this.state.previousOrder;
    sendDataLayerVariableGTM({
      "user-id": order._embedded.userSaved.id
    });
    sendCheckoutEventOrderGTM(order, 8, paymentMethod);
    sendPurchaseEventGTM(order);
  };

  setPaymentMethod = paymentMethod => {
    this.setState(
      {
        loading: true
      },
      () => {
        // console.log("paymentMethod", paymentMethod)
        if(paymentMethod.baseModule.code !== "creditcard"){
          this.checkSession(this.state.currentOrder);
          if(this.state.sessionValid){
            this.goToConfirm(
              paymentMethod,
              this.state.currentOrder
            );
          }
        } else{
          this.goToConfirm(
            paymentMethod,
            this.state.currentOrder
          );
        }
        //return paymentMethod;

        // postOrderPayment(this.state.currentOrder.id, this.state.localeString, {
        //   currencyCode: this.state.currency.isoCode,
        //   paymentMethod: paymentMethod.baseModule.id,
        //   downPayment:
        //     this.state.currentOrder.status === "USER_FILLED" &&
        //     paymentMethod.configuration.deposit !== 100
        //       ? true
        //       : false
        // })
        //   .then(payment => {
        //     console.log("xxxx", payment.payments.reduce((acc, curr) =>
        //         !acc || new Date(curr.creationDate) > new Date(acc.creationDate)
        //     ? curr
        //     : acc));
        //     postOrderPaymentEmail(payment.id, {
        //       value: payment.payments[0].clientEmail,
        //       paymentCode: payment.payments[0].paymentMethod.code,
        //       downPayment:
        //         paymentMethod.configuration.deposit === 100
        //           ? payment.totalPrice
        //           : (payment.totalPrice * paymentMethod.configuration.deposit) /
        //             100,
        //       sendType: "mail"
        //     })
        //       .then(function(response) {
        //         return response;
        //       })
        //       .catch(error => this.setState({ error }));
        //     this.goToConfirm(
        //       paymentMethod,
        //       payment.payments.reduce((acc, curr) =>
        //         !acc || new Date(curr.creationDate) > new Date(acc.creationDate)
        //           ? curr
        //           : acc
        //       )
        //     );
        //     return payment;
        //   })
        //   .catch(error => this.setState({ error }));
      }
    );
  };

  setStripePaymentMethod = (paymentMethod, payment) => {
    // Redirect if callbackStripe is set for open-api users
    //console.log(this.state.callbackStripe);
    if (this.state.callbackStripe) {
      //console.log(this.state.urlToShop);
      window.location.href =
        PHP_API_ENDPOINT +
        "/payment-confirmation/" +
        this.state.currentOrder.id +
        "/" +
        this.state.urlToShop;
      return;
    } else {
      // console.log("paymentMethod", paymentMethod)
      // console.log("payment", payment)
      this.goToConfirm(paymentMethod, payment);
    }
  };

  toggleProductsViewMode = () => {
    this.setState(prevState => ({
      productsListViewMode: !prevState.productsListViewMode
    }));
  };

  onSelectProduct = (productId: number) => {
    route(`/${this.state.hash}/products/${productId}`, true);
    this.setState({ showBackToProduct: false });
    setTimeout(() => {
      parent.postMessage(`scroll_top`, "*");
    }, 500);
  };

  checkSession = (order) => {

    // Utilisation de reduce pour trouver l'objet avec la plus petite creationDate
    var smallestBookingCreationDate = order._embedded.bookings.reduce((minBooking, currentBooking) => {
      var currentBookingCreationDate = new Date(currentBooking.creationDate);
      var minBookingCreationDate = new Date(minBooking.creationDate);
        // Comparaison basée sur creationDate
        return currentBookingCreationDate.getTime() < minBookingCreationDate.getTime() ? currentBooking : minBooking;
      }, order._embedded.bookings[0]); // Utilisation de bookings[0] comme valeur initiale

      let creationDate = new Date(smallestBookingCreationDate.creationDate);

      let now = new Date();
      let timeDiff = Math.abs(
        creationDate.getTime() - now.getTime()
      );
      //console.log('timeDiff', timeDiff )
      // console.log('orderRef', this.state )
      // console.log("smallestBookingCreationDate", smallestBookingCreationDate ); // Affiche 1

    if (timeDiff > 900000) {
      this.setState(prevState => {
        return {
          sessionValid : false,
          currentOrder: undefined
        };
      });
      route(`/order/expired`);
      return false;
    } else{
      return true;
    }
  }

  setOrderByReference = (orderReference: string) => {
    setGenerateTokenMethod(() => generateTokenByOrderReference(orderReference));
    getOrderByReference(orderReference)
      .then(orderInfos => {
        this.setState({
          orderRef: orderInfos
        });
        return Promise.all([
          orderInfos,
          getOrderById(orderInfos.id, orderReference, orderInfos.locale)
        ]);
      })
      .then(([orderInfos, order]) => {
        let config = {
          company: {
            id: order._embedded.company.id
          }
        };

        this.setState({ locale: order.locale, localeString: order.locale });
        this.setState({ config, currentOrder: order, loading: false }, () => {

            //console.log("a ton lordier ?", order);
            postParamsInURL({ params: window.location.search }, order.id)
            .then(
              function(response) {
                const getContext = response.context
                  ? response.context
                  : undefined;
                const getUrlCallbackStripe = response.urlcallback
                  ? response.urlcallback
                  : undefined;
                const getUrlToShop = response.urlredirect
                  ? response.urlredirect
                  : undefined;

                this.setState({
                  callbackStripe: getUrlCallbackStripe
                    ? getUrlCallbackStripe
                    : undefined,
                  urlToShop: getUrlToShop ? getUrlToShop : undefined
                });

                let creationDate = new Date(order.creationDate);
                let now = new Date();
                let timeDiff = Math.abs(
                  creationDate.getTime() - now.getTime()
                );

                if (timeDiff > 900000) {
                  route(`/order/expired`);
                } else {
                  if (order.balance > 0) {
                    const userSaved = order._embedded.userSaved;

                    if (userSaved) {
                      if (order.origin === "KIOSK") {
                        this.getPayments(
                          { type: getContext ? getContext : "WIDGET" },
                          order,
                          false
                        );
                        //this.setState({ isRedirectToPayment: true });
                        //route(`/order/${order.id}/client`);
                         this.getAllParticipantClientForm(order)
                          .then(({ hasForms }) => {
                            if (!hasForms) {
                              // Aucun formulaire trouvé → on redirige
                              route(`/order/${order.id}/client`);
                            }
                          })
                          .catch(error => {
                            console.error("Erreur lors de la vérification du formulaire client :", error);
                          });
                      } else {
                        //if (userSaved.firstName !== "") {
                         // route(`/order/${order.id}`);
                        this.getAllParticipantClientForm(order)
                          .then(({ hasForms }) => {
                            if (order.origin === "OPEN_API") {
                              // Aucun formulaire trouvé → on redirige
                              route(`/order/${order.id}`);
                            } else{
                              route(`/order/${order.id}/client`);
                            }
                          })
                          .catch(error => {
                            console.error("Erreur lors de la vérification du formulaire client :", error);
                          });


                          // this.getPayments(
                          //   { type: getContext ? getContext : "WIDGET" },
                          //   order,
                          //   true
                          // );
                        //}
                      }
                    } else {
                      this.getPayments(
                        { type: getContext ? getContext : "WIDGET" },
                        order,
                        false
                      );
                      //this.setState({ isRedirectToPayment: true });
                      //route(`/order/${order.id}/client`);
                       this.getAllParticipantClientForm(order)
                          .then(({ hasForms }) => {
                            if (!hasForms) {
                              // Aucun formulaire trouvé - on redirige
                              route(`/order/${order.id}/client`);
                            }
                          })
                          .catch(error => {
                            console.error("Erreur getAllParticipantClientForm :", error);
                          });
                    }
                  } else if (order.balance == 0 || order.balance == null) {
                    // commande payé + order.balance == 0 || order.balance == null
                    if(order.status == "FULLY_PAID"){
                      // callbackStripe on appel url de retour (Vente OS)
                      if(getUrlCallbackStripe){
                        window.location.href = PHP_API_ENDPOINT + "/payment-confirmation/" + this.state.currentOrder.id + "/" + getUrlToShop;
                        return;
                      }
                      // fonctionnement classique + creation compo "fullypaid"
                      else {
                        var paymentMethod = {
                          baseModule: {
                            code: "fullypaid"
                          }
                        };
                        this.setState(prevState => {
                          return {
                            paymentMethod: paymentMethod,
                            previousOrder: order,
                                                    };
                        })
                        route(`/order/${order.id}/payment/confirmation`);
                      }

                    }
                    // si order.status n'est pas "FULLY_PAID" && order.balance == 0 || order.balance == null => freeorder
                    // redirection vers la page de /order/${order.id}
                    else {
                      var paymentMethod = {
                        baseModule: {
                          code: "freeorder"
                        }
                      };

                      this.setState(prevState => {
                        return {
                          paymentMethod: paymentMethod                          };
                      });
                      route(`/order/${order.id}`);

                    }
                  }
                }
                return response;
              }.bind(this)
            )
              .catch(error => this.setState({ error }));
        });
        return order;
      })
      .catch(error => console.error(error));
  };

  goToClientForm = order => {
 this.getAllParticipantClientForm(order)
    .then(({ hasForms }) => {
      if (!hasForms) {
        // Aucun formulaire trouvé - on redirige
        route(`/order/${order.id}/client`);
      }
    })
    .catch(error => {
      console.error("Erreur getAllParticipantClientForm :", error);
    });
    //route(`/order/${order.id}/client`);
  };


  goToParticipantClientForm = order => {
    route(`/order/${order.id}/participantclientforms`);
  };

    getAllParticipantClientForm = currentOrder => {
     return Promise.all(
         currentOrder._embedded.bookings.map(booking =>
            Promise.all([
              booking._embedded.product.type != "GIFT"
              ?
              getParticipantClientForm(booking.id,this.state.localeString).catch(error => {
                if (error.status !== 404) {
                  this.setState({ error });
                  throw new Error();
                } else {
                  return;
                }
              }) : Promise.resolve(undefined),
              booking,
             // getParticipantClientData(booking.id)
            ])
          )
        )
          .then(responseArray => {

            // console.log("getAllParticipantClientForm - responseArray", responseArray)
            // console.log("getAllParticipantClientForm - currentOrder", currentOrder)

              //on check si les formulaire sont saisie ou non -- a voir 
                // let allParticipantExists = false;
                // let allValuesFilled = true;              
                // responseArray.map(bookingsParticipantClientForm => {
                //       console.log("getAllParticipantClientForm - bookingsParticipantClientForm", bookingsParticipantClientForm)
                //       let participantClientForm = bookingsParticipantClientForm[0];
                //       let participantClientData = bookingsParticipantClientForm[2]._embedded.clientData;
                      
                //         for (
                //         let indexParticipant = 1;
                //         indexParticipant <= bookingsParticipantClientForm[1].quantity;
                //         indexParticipant++
                //       ) {
                //           const participantExists = participantClientData.some(item => item.participantIndex === indexParticipant);
                //           if (!participantExists) {
                //               allValuesFilled = false;
                //               break;
                //           } else {
                //               allParticipantExists = true
                //               for (
                //                 let indexForm = 0;
                //                 indexForm < participantClientForm.length;
                //                 indexForm++
                //               ) {
                //                 const item = participantClientForm[indexForm];
                //                   if (item.mandatory) {
                //                     if (
                //                       item._embedded.clientFormInputType.id ===
                //                       participantClientData[indexForm]._embedded.clientFormInputTypeSaved.id
                //                     ) {
                //                         // Vérifier si le champ 'value' est vide ou non défini
                //                       if (!item.value || item.value.trim() === '') {
                //                         allValuesFilled = false;
                //                         break;
                //                       }
                //                         }
                //                     }
                //                 }
                //           }
                //         }


                //       console.log("getAllParticipantClientForm - participantClientForm", participantClientForm)
                //       console.log("getAllParticipantClientForm - participantClientData", participantClientData)

                //       console.log("getAllParticipantClientForm - allParticipantExists", allParticipantExists)
                //       console.log("getAllParticipantClientForm - allValuesFilled", allValuesFilled)
                 
                // }) 

              //
                const hasForms = responseArray.some((ParticipantClientForm) => ParticipantClientForm[0] !== undefined);
                if (hasForms) {
                          this.setState({
                            allParticipantClientForm: responseArray
                          }, 
                          () => {
                              this.goToParticipantClientForm(currentOrder);
                          });
                }

                return { responseArray, hasForms };
          })
          .catch(error => {
              console.error("Error getParticipantClientForm", error);
              return { responseArray: [], hasForms: false };
          });
  } 

  goToCatalog = () => {
    const { hash, config } = this.state;

    if (config.module.conf.mode == "catalog") {
      route(`/${hash}/products`);
    } else {
      route(`/${hash}/products/${config.module.conf.id_product}`);
    }
    setTimeout(() => {
      parent.postMessage(`scroll_top`, "*");
    }, 500);
  };

  backToProduct = () => {
    this.setState({ productPageUpdate: true, showBackToProduct: false });
  };

  onEnterBooker = () => {
    this.setState({ productPageUpdate: false, showBackToProduct: true });
  };

  goToPayment = () => {
    const { config, currentOrder } = this.state;

    //stepGTM 7 : Finaliser ma commande APRES informations clients;
    sendCheckoutEventOrderGTM(this.state.currentOrder, 7, false);

    if (currentOrder.totalPrice === 0 || currentOrder.totalPrice === null) {
      let payment = {
        paymentMethod: 16,
        description: "Paiement par bon cadeau",
        status: "CONFIRMED",
        note: "",
        callbackStripe : this.state.callbackStripe ?  this.state.callbackStripe : ''
      };
      return postOrderPayment(currentOrder.id, this.state.localeString, payment)
        .then(payment => {
          this.setState({
            paymentMethod: {
              baseModule: {
                code: "freeorder"
              }
            }
          });
          if(this.state.callbackStripe){
            window.location.href =
              PHP_API_ENDPOINT +
              "/payment-confirmation/" +
              currentOrder.id +
              "/" +
              this.state.urlToShop;
            return;
          } else{
            route(`/order/${currentOrder.id}/payment/confirmation`);
            this.setState(prevState => {
              return {
                loading: false,
                currentOrder: undefined,
                previousOrder: prevState.currentOrder
              };
            });
          }
          return payment;
        })
        .catch(error => this.setState({ error }));
    } else {
      this.getPayments(config, currentOrder, true);
    }
  };

  getPayments(config, order, isRedirect) {
    //console.log("order", order)
    getPaymentMethods(
      order._embedded.company.id,
      order.id,
      config.type ? config.type : "WIDGET",
      config && config.module ? false : true,
      order.locale
    )
      .then(paymentMethods => {
        //console.log("paymentMethods", paymentMethods)
        const closestBookingStartTime = order._embedded.bookings.reduce(
          (acc, currentBooking) =>
            !acc || new Date(acc) > new Date(currentBooking.startTime)
              ? currentBooking.startTime
              : acc,
          undefined
        );
        if (!paymentMethods) {
          return [];
        }
        let filterPaymentMethod = paymentMethods.filter(paymentMethod => {
          // Dans le cas d'un order initié depuis le shop, la route de l'api php qui renvoie les paymentMethod possibles renvoie la configuration pour une origin "widget". Or coté back, quand on crée le pi_... pour afficher le StripeElement, on utilise la configuration issue du module shop pour le mode creditcard (avec toujours un pourcentage de 100%). En théorie, on devrait ré-ajuster la route qui renvoie les paymentMethod possible,  pour la rendre cohérente avec ce qui est fait quand on crée le pi_.... Provisoirement, on met "en dur" côté wigdet le fait que c'est 100% d'acompte pour le paiement par carte si l'origine de l'order est Shop.  Cf https://redmine.op6m.fr/issues/68124
          if(paymentMethod.baseModule.code === "creditcard" && paymentMethod.configuration && order.origin == "SHOP"){
            paymentMethod.configuration.deposit = 100;
          }

          if (
            paymentMethod.configuration &&
            !paymentMethod.configuration.daysBefore
          ) {

            return true;
          } else {


            let todayPlusDelay = new Date();
            let daysBefore = paymentMethod.configuration
              ? paymentMethod.configuration.daysBefore
              : 0;
            todayPlusDelay.setDate(todayPlusDelay.getDate() + daysBefore);
            return (
              paymentMethod.configuration &&
              paymentMethod.configuration.alwaysActived !== 1 &&
              paymentMethod.configuration.daysBefore &&
              todayPlusDelay < new Date(closestBookingStartTime)
            );
          }
        });
        return filterPaymentMethod.length
          ? filterPaymentMethod
          : paymentMethods;
      })
      .then(paymentMethods => {
        if (paymentMethods.length > 0) {
          if (
            !paymentMethods.find(
              paymentMethod => paymentMethod.baseModule.code === "creditcard"
            )
          ) {
            /*
              10/08/2022 vu JMM/OTO
              si pas de paiement CB alors on empêche le passage à l'étape des autres moyens de paiement
              raison : l'utilisation d'un autre moyen de paiement interroge si il y a strype
              ce n'est pas cohérent mais pour le moment on fait comme ca
            */
            this.setState({ noPayment: true });
            return "";

            //on ne revoi plus les autres methodes de paiement
            /*this.setState({
              paymentMethods
            });
            route(`/order/${order.id}/otherPaymentMethods`);*/
          } else {
            this.setState({
              paymentMethods,
              paymentMethod: paymentMethods.find(
                paymentMethod => paymentMethod.baseModule.code === "creditcard"
              )
            });
            if (isRedirect) {
              route(`/order/${order.id}/payment`);
            }
          }
          return paymentMethods;
        } else {
          this.setState({ noPayment: true });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  pageDidMountOrUpdate = () => {
    const { hash } = this.state;
    //console.log('this.state', this.state)
    let widgetEl = document.getElementById("widget");
    if (widgetEl) {
      let height = widgetEl.clientHeight;
      const width = widgetEl.clientWidth;

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = setTimeout(() => {
//      console.log("widgetEl.clientHeight", widgetEl.clientHeight)
//      console.log("widgetEl.clientHeight !== height", widgetEl.clientHeight !== height)
      //if (widgetEl.clientHeight !== height) {
        if (height < 357) {
          height = 357;
        }
        parent.postMessage(
          `action=resize&height=${height}&width=${width}&id_iframe=${hash}`,
          "*"
        );
      //}
      this.timeoutId = null; // libération
    }, 500);
    }
  };

  onUnload = event => {
    // Enable redirection if callbackStripe is set for open-api users
    if (this.state.callbackStripe) {
      return;
    }

    // the method that will be used for both add and remove event
    if (this.state.currentOrder) {
      const confirmationMessage =
        "Etes-vous sur de quitter cette page ? Toutes les produits ajoutés à votre panier seront perdues...";
      event.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
      return confirmationMessage; // Gecko, WebKit, Chrome <34
    }
  };

  componentDidUpdate() {
    this.pageDidMountOrUpdate();
    if (this.options && this.options.style) {
      const loadCSS = new LoadCSS();
      loadCSS.load(this.options.style);
      const getWidget = document.getElementById("widget");
      getWidget.classList.add(`widget__${this.options.style.split(".")[0]}`);
    }
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onUnload);
    window.addEventListener("resize", this.pageDidMountOrUpdate);
    // window.addEventListener('message', this.handleFrameTasks);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onUnload);
    window.removeEventListener("resize", this.pageDidMountOrUpdate);
    // window.removeEventListener('message', this.handleFrameTasks);
  }

  removeBeforeUnloadListener = () => {
    window.removeEventListener("beforeunload", this.onUnload);
    window.removeEventListener("resize", this.pageDidMountOrUpdate);
  };

  changeLoadingState = () => {
    this.setState({ loading: false });
  };
  // handleFrameTasks = e => {
  //   console.log('handleFrameTasks', e);
  // };

  render(
    props,
    {
      hash,
      locale,
      localeString,
      currency,
      company,
      currentOrder,
      previousOrder,
      payment,
      paymentMethod,
      paymentMethods,
      loading,
      config,
      preview,
      error,
      productsListViewMode,
      hasParticipantClientForms,
      currentProduct,
      isRedirectToPayment,
      callbackStripe,
      urlToShop,
      noPayment,
      sessionValid,
      piError,
      dataAssurance,
      initAssuranceMeetch,
      allParticipantClientForm
    }
  ) {
    return (
      <ThemeConfigProvider conf={config && config.module && config.module.conf}>
        <IntlProvider definition={locale}>
          <div id="widget" class={styles.app}>
            {this.state.customStyle}
            {this.disabledReservation}
            {error && <Error error={error} />}
            <Loading loading={loading}>Loading...</Loading>
            <div class={styles.container}>
              {config && config.module && config.module.conf && sessionValid && (
                <Match
                  path="/:hash/products/:productId"
                >
                  {({ matches, path, url }) => (
                    (path !== "/stripe/error/:Id" && path !== "/payment/error") && (
                    <Header
                      hash={hash}
                      config={config}
                      order={currentOrder}
                      matchesProduct={matches}
                      changeTranslation={this.changeTranslation}
                      showBackToProduct={this.state.showBackToProduct}
                      backToProduct={this.backToProduct}
                      goToCatalog={this.goToCatalog}
                    />
                    )
                  )}
                </Match>
              )}

              <Router>
                <Redirect
                  path="/:hash/:preview?"
                  initConfig={this.initConfig}
                />
                <Products
                  path="/:hash/products"
                  config={config}
                  company={company}
                  preview={preview}
                  currency={currency}
                  locale={localeString}
                  productsListViewMode={productsListViewMode}
                  toggleProductsViewMode={this.toggleProductsViewMode}
                  onSelectProduct={this.onSelectProduct}
                  pageDidMountOrUpdate={this.pageDidMountOrUpdate}
                  disabledReservation={this.disabledReservation}
                  options={this.options}
                />
                <Product
                  path="/:hash/products/:productId"
                  config={config}
                  preview={preview}
                  currency={currency}
                  locale={localeString}
                  currentOrder={currentOrder}
                  setCurrentProduct={this.setCurrentProduct}
                  setOrder={this.setOrder}
                  goToCatalog={
                    config &&
                    config.module &&
                    config.module.conf &&
                    this.goToCatalog
                  }
                  pageDidMountOrUpdate={this.pageDidMountOrUpdate}
                  productPageUpdate={this.state.productPageUpdate}
                  onEnterBooker={this.onEnterBooker}
                />

                <OrderSummary
                  path="/order/:orderId"
                  config={config}
                  order={currentOrder}
                  urlToShop={urlToShop}
                  locale={localeString}
                  pageDidMountOrUpdate={this.pageDidMountOrUpdate}
                  checkSession={this.checkSession}
                  viewCellSummary={false}
                  currency={currency}
                >
                  <Basket
                    config={config}
                    token={getToken()}
                    currency={currency}
                    locale={localeString}
                    order={currentOrder}
                    setOrder={this.updateOrder}
                    goToClientForm={this.goToClientForm}
                    goToPayment={this.goToPayment}
                    goToCatalog={
                      config &&
                      config.module &&
                      config.module.conf &&
                      this.goToCatalog
                    }
                    noPayment={noPayment}
                    pageDidMountOrUpdate={this.pageDidMountOrUpdate}

                    paymentMethod={paymentMethod}
                    updateDataAssurance={this.updateDataAssurance}
                    dataAssurance={dataAssurance}
                    getAssurance={this.getAssurance}
                    initAssuranceMeetch={initAssuranceMeetch}
                    
                  />
                </OrderSummary>
                <OrderSummary
                  path="/order/:orderId/client"
                  config={config}
                  order={currentOrder}
                  urlToShop={urlToShop}
                  locale={localeString}
                  checkSession={this.checkSession}
                  viewCellSummary={true}
                  currency={currency}
                >
                  <ClientForm
                    config={config}
                    token={getToken()}
                    currency={currency}
                    locale={localeString}
                    order={currentOrder}
                    setOrderUser={this.setOrderUser}
                    pageDidMountOrUpdate={this.pageDidMountOrUpdate}
                    redirectToPayment={isRedirectToPayment}
                  />
                </OrderSummary>
                <OrderExpired
                  path="/order/expired"
                  changeLoadingState={this.changeLoadingState}
                />
                <StripeError
                  path="/stripe/error/:Id"
                  changeLoadingState={this.changeLoadingState}
                  config={config}
                />
                <PiError
                  path="/payment/error"
                  changeLoadingState={this.changeLoadingState}
                  config={config}
                  error={piError}
                />
                <Checkout
                  path="/checkout/:orderReference?"
                  setOrderByReference={this.setOrderByReference}
                />
                <OrderSummary
                  path="/order/:orderId/payment"
                  config={config}
                  order={currentOrder}
                  urlToShop={urlToShop}
                  locale={localeString}
                  checkSession={this.checkSession}
                  viewCellSummary={true}
                  currency={currency}
                >
                  <StripePayment
                    hash={hash}
                    config={config}
                    currency={currency}
                    locale={localeString}
                    order={currentOrder}
                    paymentMethod={paymentMethod}
                    paymentMethods={paymentMethods}
                    setPaymentMethods={this.setPaymentMethods}
                    setOrder={this.updateOrder}
                    setPaymentMethod={this.setStripePaymentMethod}
                    removeBeforeUnloadListener={this.removeBeforeUnloadListener}
                    pageDidMountOrUpdate={this.pageDidMountOrUpdate}
                    orderRef={this.state.orderRef}
                    callbackStripe={callbackStripe}
                    urlToShop={urlToShop}
                    checkSession={this.checkSession}
                    sessionValid={sessionValid}
                    setPiError={this.setPiError}
                    dataAssurance={dataAssurance}
                    initAssuranceMeetch={initAssuranceMeetch}
                  />
                </OrderSummary>
                <Stripe3DSecureConfirmation path="/order/:orderReference/payment/3D-secure-confirmation" />
                <OrderSummary
                  path="/order/:orderId/payment/confirmation"
                  config={config}
                  order={currentOrder || previousOrder}
                  urlToShop={urlToShop}
                  locale={localeString}
                  checkSession={this.checkSession}
                  viewCellSummary={true}
                  currency={currency}
                >
                  <PaymentConfirmation
                    hash={hash}
                    config={config}
                    locale={localeString}
                    currency={currency}
                    order={previousOrder}
                    payment={payment}
                    paymentMethod={paymentMethod}
                    hasParticipantClientForms={hasParticipantClientForms}
                    dataAssurance={dataAssurance}
                    getAssurance={this.getAssurance}
                    initAssuranceMeetch={initAssuranceMeetch}
                  />
                </OrderSummary>
                <ParticipantClientForms
                  path="/order/:orderId/participantclientforms"
                  hash={hash}
                  config={config}
                  order={currentOrder}
                  localeString={localeString}
                  changeLoadingState={this.changeLoadingState}
                  currency={currency}
                  token={getToken()}
                  allParticipantClientForm={allParticipantClientForm}
                  pageDidMountOrUpdate={this.pageDidMountOrUpdate}
                /> 
                <ParticipantClientForms
                  path="/order/:orderId/participantclientforms/:orderRef"
                  config={config}
                  localeString={localeString}
                  changeLoadingState={this.changeLoadingState}
                  currency={currency}
                  changeTranslation={this.changeTranslation}
                  pageDidMountOrUpdate={this.pageDidMountOrUpdate}
                />
                <ParticipantFormCreated
                  path="/participantclientforms/created"
                  changeLoadingState={this.changeLoadingState}
                  hash={hash}
                />
              </Router>
            </div>
          </div>
        </IntlProvider>
      </ThemeConfigProvider>
    );
  }
}

export default App;
